import { h, Host } from "@stencil/core";
export class PopoverMenu {
    constructor() {
        this.placement = "bottom-end";
    }
    /** component base class */
    baseClass = "ux-popover-menu";
    render() {
        return (h(Host, { key: 'e59ed7887c242116322f544b8214d2a886fcf137', class: `${this.baseClass} ${this.baseClass}__${this.placement}` }, h("ux-popover", { key: '8fc2c0e021205ec5590d15a727439c4ac0b1e1af', placement: this.placement }, h("div", { key: 'cbb4bfc883ea97d90b295a4adc066fd048ee42ae', class: `${this.baseClass}__toggle`, slot: "trigger" }, h("span", { key: 'cd333274e20f7f93c52b8e1cd7b02c4f6ddf4f4b' })), h("ux-popover-panel", { key: 'b0e18ac48237bc03992e3247a925f4bcea906f81' }, h("div", { key: '7970901c81b5d72454ff925ecf89885b14bc559b', class: `${this.baseClass}__content` }, h("slot", { key: '1e1f180c5713664f9e97402d1f188afde17dab75' }))))));
    }
    static get is() { return "ux-popover-menu"; }
    static get originalStyleUrls() {
        return {
            "$": ["popover-menu.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["popover-menu.css"]
        };
    }
    static get properties() {
        return {
            "placement": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "PopoverPlacementType",
                    "resolved": "\"bottom\" | \"bottom-end\" | \"bottom-start\" | \"center\" | \"left\" | \"left-end\" | \"left-start\" | \"right\" | \"right-end\" | \"right-start\" | \"top\" | \"top-end\" | \"top-start\"",
                    "references": {
                        "PopoverPlacementType": {
                            "location": "import",
                            "path": "../popover/interface",
                            "id": "src/components/popover/interface.ts::PopoverPlacementType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "placement of the overlay"
                },
                "attribute": "placement",
                "reflect": false,
                "defaultValue": "\"bottom-end\""
            }
        };
    }
}
//# sourceMappingURL=popover-menu.js.map
